import moment from 'moment'
import { buildYearFilters, getDateFilterItems } from './dateFilters'

export interface DateFilter {
  name: string
  title: string
  quickFilter: { date: { filterType: string, type: string, dateFrom: string, dateTo: string } }
}

export interface PeriodFilterModelEntry {
  filterType: 'date'
  type: 'year' | 'quarter' | 'month'
  filter: number
}

// The api maps the `<type>Period` keys onto the list's date column itself
export const getPeriodFilterModel = (dateFilters: DateFilter[] = []) => {
  return dateFilters.reduce<Record<string, PeriodFilterModelEntry>>((model, { name, quickFilter }) => {
    const [, type, index] = name.match(/^(year|quarter|month)(\d+)$/) || []
    if (type === 'year' || type === 'quarter' || type === 'month') {
      model[`${type}Period`] = {
        filterType: 'date',
        type,
        filter: type === 'year' ? moment(quickFilter.date.dateFrom).year() : parseInt(index, 10) + 1,
      }
    }
    return model
  }, {})
}

export const restoreDateFilterState = (savedDateFilters: DateFilter[] = []) => {
  const isSaved = (item: DateFilter) => savedDateFilters.some(saved => saved?.name === item.name && saved?.title === item.title)
  const dateFilterItems = getDateFilterItems(buildYearFilters().find(isSaved))
  const { years, quarters, months } = dateFilterItems

  return { dateFilterItems, dateFilters: [...years, ...quarters, ...months].filter(isSaved) }
}
